/**
 * 直播管理
 */
export default {
  /* 直播分类 */
  getLiveCategoryList: "/liveCategory/selectList",  // 列表
  getLiveCategoryListPage: "/liveCategory/pageList",  // 列表分页
  newAddLiveCategory: "/liveCategory/add",  // 新增
  newUpdateLiveCategory: "/liveCategory/update",  // 修改
  newDeleteLiveCategory: "/liveCategory/delete",  // 删除

  /* 直播列表 */
  selectLiveInfoPage: "/liveInfo/selectLiveInfoPage",  // 列表
  insertLiveInfo: "/liveInfo/insertLiveInfo",  // 新增
  updateLiveInfo: "/liveInfo/updateLiveInfo",  // 修改
  selectLiveInfoDetail: "/liveInfo/selectLiveInfoDetail",  // 详情
  deleteLiveInfo: "/liveInfo/deleteLiveInfo",  // 删除
  updateLiveRecommendFlag: "/liveInfo/updateRecommend",  // 修改是否推荐
  updateOnlineStatusLive: "/liveInfo/updateOnlineStatus",  // 上下架
  selectUserBuyPageLive: "/liveInfo/selectUserBuyPage",  // 已购
}
